import {
    Grid,
    HorizontalScroller,
    Stack,
    useDataGridOptions,
} from "@biggeo/bg-ui/lab";
import isEmpty from "lodash/isEmpty";

import { useUserContext } from "../../common/components/UserContextProvider";
import MyDataView from "../views/MyDataView";
import {
    DataSourceWithConfigAndEtlExtended,
    useFetchDatascapeDataSourcesQuery,
    useListenToComputeChangesSubscription,
} from "@biggeo/bg-server-lib/studio";
import { useOpenModal } from "../../common/redux/hooks";
import { EnableHotComputeContainer } from "../views/EnableHotComputeContainer";
import { useEffect } from "react";
import { DisableHotComputeContainer } from "../views/DisableHotComputeContainer";
import { ComputeLimitContainer } from "./ComputeLimitContainer";
import { StorageLimitContainer } from "./StorageLimitContainer";
import { Routes } from "../../navigation/redux/model";

export interface IMyDataContainer {
    onAddOnDatalabClick: () => void;
}

const MyDataContainer = ({ onAddOnDatalabClick }: IMyDataContainer) => {
    const openModal = useOpenModal();

    const {
        filterSearchPaginateProps,
        dataGridFetchInputProps: { sortModel, ...rest },
    } = useDataGridOptions(20);

    const { organization } = useUserContext();

    const {
        queryReturn: { data, loading, refetch },
    } = useFetchDatascapeDataSourcesQuery({
        variables: {
            input: {
                options: rest,
                fkOrganizationId: organization?.id,
            },
        },
    });

    const { data: statusData } = useListenToComputeChangesSubscription({
        variables: {
            channel: `${organization?.id}-compute`,
        },
        fetchPolicy: "no-cache",
        shouldResubscribe: true,
    });

    const toIndexingPage = (dataSourceId: string) => {
        window.open(`${Routes.indexDataSource}/${dataSourceId}`, "_blank");
    };

    const onEnableHotCompute = (data: DataSourceWithConfigAndEtlExtended) => {
        openModal({
            component: (
                <EnableHotComputeContainer
                    datasource={data}
                    onConfirm={() => refetch()}
                />
            ),
            modalType: "new-dialog",
        });
    };

    const onDisableHotCompute = (data: DataSourceWithConfigAndEtlExtended) => {
        openModal({
            component: (
                <DisableHotComputeContainer
                    datasource={data}
                    onConfirm={() => refetch()}
                />
            ),
            modalType: "new-dialog",
        });
    };

    useEffect(() => {
        if (
            statusData?.listenToComputeChanges &&
            statusData?.listenToComputeChanges.length > 0
        ) {
            refetch();
        }
    }, [statusData?.listenToComputeChanges, refetch]);

    return (
        <Stack
            height="100%"
            sx={{
                paddingTop: 2,
            }}
        >
            <HorizontalScroller
                maxHeight={29}
                slotProps={{
                    scrollContainer: {
                        gap: 4,
                    },
                }}
            >
                <Grid minWidth={95} height="100%">
                    <ComputeLimitContainer />
                </Grid>
                <Grid minWidth={95} height="100%">
                    <StorageLimitContainer />
                </Grid>
            </HorizontalScroller>
            <MyDataView
                data={data?.fetchDatascapeDataSources || { data: [], total: 0 }}
                loading={loading}
                pagination={filterSearchPaginateProps}
                onAddOnDatalabClick={onAddOnDatalabClick}
                onEnableHotCompute={onEnableHotCompute}
                onDisableHotCompute={onDisableHotCompute}
                toIndexingPage={toIndexingPage}
            />
        </Stack>
    );
};

export default MyDataContainer;
